<!-- 盘库菜单页 -->
<template>
    <div class="app-container">
        <el-tabs
            v-model="TabsValue"
            type="card"
            class="demo-tabs"
        >
        <el-tab-pane
            label="库存详情"
            name="1"
            >
           <checkInventoryDetail :checkInventoryRecord="checkInventoryRecord" />
        </el-tab-pane>   
        <el-tab-pane
            label="出入库记录"
            name="2"
            >
            <checkInventoryOutIn :checkInventoryRecord="checkInventoryRecord" />
        </el-tab-pane>   
        <el-tab-pane
            label="库存盘点"
            name="3"
            v-if="!approval"
            >
            <checkInventory :checkInventoryRecord="checkInventoryRecord"/>
        </el-tab-pane>   
        <el-tab-pane
            label="库存审批"
            name="3"
            v-else
            >
            <approvalInventory :checkInventoryRecord="checkInventoryRecord"/>
        </el-tab-pane>   
        </el-tabs>
    </div>
  </template>
  
  <script setup>
  
  import checkInventoryDetail from "./checkInventoryDetail.vue";
  import checkInventoryOutIn from "./checkInventoryOutIn.vue";
  import checkInventory from "./checkInventory.vue";
  import approvalInventory from "./approvalInventory.vue";
  import { ref,watch} from "vue";
  import { useRoute } from 'vue-router'
  /**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
//   defineOptions({
//     name: "checkInventoryMenu",
//   });
  const checkInventoryRecord = ref()
  const approval = ref(false)
//   const checkInventoryRecordStatus = ref('')
  const TabsValue = ref('1')
  const route = useRoute()
   watch(() => route.query,
        (newVal, oldVal) => {
            if(Object.keys(newVal).length>0){
                if(newVal.data){
                    checkInventoryRecord.value = JSON.parse(newVal.data)
                }
                if(newVal.type){
                    approval.value = true
                }else{
                    approval.value = false
                }
            }
            // checkInventoryRecordStatus.value = newVal.checkInventoryRecordStatus || ''
            // proSearch()
        }, {
        immediate: true,
        deep:true
        }
    )
  </script>
  
  <style lang="scss" scoped>
    .demo-tabs > .el-tabs__content {
        padding: 32px;
        color: #6b778c;
        font-size: 32px;
        font-weight: 600;
    }
</style>
  